'use client';

import { useListingSearchStore } from '@/store';
import { ErrorBoundary } from '@/components/base/Layout/ErrorBoundary';
import { usePopupWizard } from '@/component/Modal';
import {
  SearchListingButton,
  SearchListingDateField,
  SearchListingGuestsField,
  SearchListingLocationField,
} from './fields';
import { SearchListingDivider } from './components/Divider';
import { SearchListingContainer } from './components/SearchListingContainer';

export const SearchHome = () => {
  const { currentStep, onSetStep } = usePopupWizard([
    'location',
    'date',
    'guests',
  ]);
  const { focusField } = useListingSearchStore();
  return (
    <ErrorBoundary tags={{ feature: 'search_home' }} fallbackClassName="my-6">
      <SearchListingContainer
        className="mx-auto max-sm:mt-[38px] sm:mt-4 lg:mt-8 max-sm:shadow-[0px_0px_40px_0px_rgba(0,78,82,0.20)]"
        isFocused={Boolean(focusField)}
      >
        <SearchListingLocationField
          currentStep={currentStep}
          onSetStep={onSetStep}
        />
        <SearchListingDivider />
        <SearchListingDateField
          currentStep={currentStep}
          onSetStep={onSetStep}
        />
        <SearchListingDivider />
        <SearchListingGuestsField
          currentStep={currentStep}
          onSetStep={onSetStep}
        />
        <SearchListingButton pageName="landing" />
      </SearchListingContainer>
    </ErrorBoundary>
  );
};
